export default {"src":"/_next/static/media/doorman.13c2f765.svg","height":100,"width":100};